<template>
    <router-view></router-view>
    <Loading v-if="isLoading" />
</template>
<script>
import Loading from "./components/UI/Cards/Loading.vue";
import { mapGetters } from "vuex";

export default {
    components: { Loading },
    computed: {
        ...mapGetters(["isLoading"]),
    },
};
</script>
